<template>
    <div>
        <div class="table-area">
            <div class="table-b" style="margin-bottom: 10px">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name">방문객 정보<span style="color: #FF7F50; font-size: 16px" v-if="this.blackInfoYn">&nbsp ■ 블랙리스트 대상자</span></h3>
                    </div>
                  <div class="btn-wrap btn-type2 clearfix" style="margin-bottom: 0px">
                    <button class="btn-size btn-w-gray" @click="popAddVisitor()" v-if="showAdd">
                      <span class="btn-icon">
                        <i class="fas fa-plus"></i>
                      </span>
                      인원추가
                    </button>
                  </div>
                </div>
                <div class="grid-wrap">
                    <dhx-grid ref="grid" v-model="visitorList" :config="config" @constructGridSuccessful="constructGridSuccessful"/>
                </div>
            </div>
            <visitor-history v-model="value" :visitorSeq="visitorSeq" :visitorNm="visitorNm" v-if="visitStat=='50' || visitStat=='60'" @input="$forceUpdate()"/>
        </div>
        <!-- //테이블 -->
    </div>
</template>

<script>
    import mixin from '@/mixin';
    import mixinSlip from '@/mixin/slip';
    import _ from 'lodash'
    import DhxGrid from '@/components/DhxGrid.vue'
    import VisitorHistory from '@/components/visit/VisitorHistory.vue'
    import SecuDetail from '@/components/SecuDetail.vue'
    import CarDetail from '@/components/CarDetail.vue'
    import VisitDetailAdd from '@/components/VisitDetailAdd.vue'

    export default {
        name: 'VisitDetail',
        props: {
            'value': {
                type: Object,
                required: true
            },
            status: {
                type: Object,
                required: false,
                default () {
                    return {
                        memento: [],
                        readonly: false
                    }
                }
            },
        },
        mixins: [mixin, mixinSlip],
        components: {DhxGrid, VisitorHistory, SecuDetail, CarDetail, VisitDetailAdd},
        data() {
            return {
                config : {
                    columns: [
                        {id: 'visitorSeq',align: 'center',value: 'No.',width: 35},
                        {id: 'visitorNm',align: 'center',value: '방문자명',width: 50},
                        {id: 'visitorBirth',align: 'center',value: '생년월일',width: 80},
                        {id: 'visitorMobile',align: 'center',value: '연락처',width: 100},
                        {
                            value: '보안물품',
                            component: {
                                template: `<div class="btn-wrapper" v-if="this.value.secuYn ==='Y'"><button type="button" class="btn btn-primary btn-block" @click="showSecuDetail()">내역</button></div>`,
                                methods: {
                                    showSecuDetail() {
                                        this.$modal.open({
                                            component: SecuDetail,
                                            props: {
                                                visitNo: this.$parent.$parent.value.visitNo,
                                                visitorSeq: this.value.visitorSeq,
                                                visitorNm: this.value.visitorNm
                                            },
                                            parent: this,
                                            width: 1000
                                        })
                                    },
                                }
                            },
                            width: 80
                        },
                        {
                            value: '차량정보',
                            component: {
                                template: `<div class="btn-wrapper" v-if="this.value.carYn ==='Y'"><button type="button" class="btn btn-primary btn-block" @click="showCarDetail()">내역</button></div>`,
                                methods: {
                                    showCarDetail() {
                                        this.$modal.open({
                                            component: CarDetail,
                                            props: {
                                                visitNo: this.$parent.$parent.value.visitNo,
                                                visitorSeq: this.value.visitorSeq,
                                                visitorNm: this.value.visitorNm
                                            },
                                            parent: this,
                                            width: 800
                                        })
                                    },
                                }
                            },
                            width: 80
                        },
                        {id: 'regNm',align: 'center',value: '추가등록자',width: 50},
                        {
                            value: '거부처리',
                            component: {
                                template: `<div class="btn-wrapper" v-if="this.show"><label class="switch"><input type="checkbox" :checked="this.value.allowYn ==='N'" @click="doAllowYn()"><span class="slider round"></span></label></div>
                                           <div class="btn-wrapper" v-else><span class="btn-icon red" v-if="this.value.allowYn==='N'"><i class="fas fa-check fa-lg" style="color:red"></i></span></div>`,
                                data() {
                                    return {show: ''}
                                },
                                mounted() {
                                    this.show = this.$parent.$parent.$parent.$parent.isSubmitable ||
                                        ((this.$store.state.loginInfo.loginId === this.$parent.$parent.thisApprVisit || this.$parent.$parent.$parent.$parent.deleYn ==='Y') &&
                                        this.$parent.$parent.docStatCd !== 'DRP') ||
                                        this.$store.state.loginInfo.authorities[0].roleCd ==='ADMIN'
                                },
                                methods: {
                                    doAllowYn() {
                                        this.$http.post(`/api/visit/save/visitor/allowYn`, this.value
                                        ).then((response) => {
                                            if(this.value.allowYn==='Y')
                                                this.$parent.$parent.visitorList[this.value.visitorSeq-1].allowYn = 'N'
                                            else
                                                this.$parent.$parent.visitorList[this.value.visitorSeq-1].allowYn = 'Y'
                                        }).catch((e) => {
                                            console.error(e);
                                        })
                                    },
                                    showAlert() {
                                        this.$swal({
                                            type: 'error', text: '입퇴실 조건에 해당되지 않습니다.'
                                        })
                                    },
                                }
                            },
                            width: 50
                        },
                        {id: 'blackYn',align: 'center',value: '블랙여부',width: 100, hide:true},
                    ],
                    height: 240,
                    enablePaging: false,
                    afterRefreshData(grid, data) {
                        this.$nextTick(() => {
                            _.forEach(data, (item, index) => {
                                let rId = index + 1
                                grid.cells(rId, 2).setValue(this.$moment(grid.cells(rId, 2).getValue()).format('YYYY-MM-DD'))
                                if(grid.cells(rId, 8).getValue()==='Y') grid.setRowColor(rId,"coral");
                            })
                        })
                    },
                },
                title: '방문 관리',
                visitorSeq: '',
                visitorNm: '',
                visitStat: '',
                visitorList: [],
                blackInfoYn: false,
                docStatCd: '',
                thisApprVisit: ''
            };
        },
        methods: {
            constructGridSuccessful(grid) {
                grid.attachEvent('onRowSelect', (rId) => {
                    let visitorSeq = grid.cells(rId,0).getValue();
                    let visitorNm = grid.cells(rId,1).getValue();
                    this.visitorSeq = visitorSeq
                    this.visitorNm = visitorNm
                });
            },
            saveExcel() {
                this.downloadExcel(this.$refs.grid);
            },
            popAddVisitor() {
              let vm = this
              this.$modal.open({
                component: VisitDetailAdd,
                props: {
                  compCd: this.value.compCd,
                  visitNo: this.value.visitNo,
                  visitorList: this.value.visitDetails
                },
                parent: this,
                events: {
                  close(data) {
                    // Close event handler
                    vm.getVisitors(data)
                  }
                },
                width: 600
              })
            },
            getVisitors(visitNo) {
              this.$http.get(`/api/visit/detail/${visitNo}`)
                  .then(response => {
                    let data = response.data

                    //핸드폰 번호 유형으로 변환
                    let regExp =/(01[016789])([0-9]{1}[0-9]{2,3})([0-9]{4})$/
                    let myArray
                    for(let i=0; i<data.length; i++){
                      myArray = regExp.exec(data[i].visitorMobile)
                      data[i].visitorMobile = myArray[1] + '-' + myArray[2] + '-' + myArray[3]
                    }

                    this.visitorList = data
                    this.value.visitDetails = data
                  })
            }
        },
        mounted() {
        },
        computed: {
          showAdd() {
            return this.$parent.$parent.isSubmitable ||
                ((this.$store.state.loginInfo.loginId === this.thisApprVisit || this.$parent.$parent.deleYn === 'Y') && this.docStatCd !== 'DRP') ||
                this.$store.state.loginInfo.authorities[0].roleCd ==='ADMIN'
          }
        },
        watch: {
            value: {
                immediate: true,
                deep: true,
                handler(value) {
                    this.visitorList = value.visitDetails
                    this.visitStat = value.visitStatCd
                    this.docStatCd = value.docStatCd
                    this.thisApprVisit = value.thisApprVisit
                    if(this.visitorList.length !== 0) {
                        this.visitorSeq = this.visitorList[0].visitorSeq
                        this.visitorNm = this.visitorList[0].visitorNm
                        this.blackInfoYn = false
                        for(let i=0; i<this.visitorList.length; i++){
                            if(this.visitorList[i].blackYn==='Y')
                                this.blackInfoYn = true
                        }
                    }
                }
            },
            'status.readonly'() {
                this.$parent.getVisit()
            },
        }
    };
</script>

<style scoped>
    .desc-content:after {
        clear: both;
        content: '';
        display: block;
    }

    .btn-wrap {
        margin-bottom: 20px;
    }

    .desc-content {
        border: 2px solid #9db6c9;
        background: #f9fafc;
        margin: 0 0 20px 0;
        border-radius: 4px;
        padding: 15px 2%;
        clear: both;
    }

    .desc-content .item {
        float: left;
    }

    .desc-content .item .desc-item {
        position: relative;
        padding-left: 82px;
        margin-bottom: 8px;
    }

    .desc-content .item .desc-item:last-child {
        margin-bottom: 0;
        height: 25px;
    }

    .desc-content .item .desc-item .tit {
        position: absolute;
        left: 0;
    }

    .desc-content .item .desc-item .label-tit {
        font-family: 'NotoM';
        color: #222;
        font-size: 15px;
    }

    .desc-content .item.desc-left .desc-item {
        padding-left: 90px;
    }

    .desc-content .item.desc-left .desc-item .desc:after {
        clear: both;
        content: '';
        display: block;
    }

    .desc-content .item.desc-left .desc-item .desc .datepicker {
        float: left;
    }

    .desc-content .item.desc-left .desc-item .desc span.wave {
        float: left;
        padding: 0 6px;
    }

    .desc-content .item.desc-left .desc-item .td-s-thumb.search-area input,
    .desc-content .item.desc-left .desc-item .td-s-thumb.search-area .ip-box {
        float: left;
    }

    .desc-content .item.desc-left .desc-item .desc.select select {
        width: 70%;
    }

    .desc-content .item.desc-left {
        width: 35%;
        padding-right: 40px;
    }

    .desc-content .item.desc-center {
        width: 35%;
        padding-right: 40px;
    }

    .desc-content .item.desc-right {
        width: 30%;
    }

    .search-area input {
        position: relative;
    }

    .search-area .icon {
        position: absolute;
        right: 8px;
        top: 1px;
        z-index: 100;
        cursor: pointer;
        font-size: 16px;
        color: #555;
    }

    .search-border .td-s-thumb {
        position: relative;
        display: inline-block;
    }

    .search-border .td-s-thumb.search-area > input,
    .search-border .td-s-thumb.search-area > .ip-box
    .search-border .td-s-thumb.search-area > button {
        float: left;
    }

    .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
        width: 60%;
        margin-left: 6px;
    }

    .search-border .td-s-thumb.search-area .ip-box {
        vertical-align: top;
    }

    @media (max-width: 1580px) {
        .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
            width: 50%;
        }
    }
</style>

